module.exports = __webpack_public_path__ + "img/header-car-glow.9ea32ebe.png";